import {SafeHtml} from "@angular/platform-browser";

export class SelectElement {

    value: any;
    label: string;
    html?: SafeHtml;

    constructor(value: any, label: string) {
        this.value = value;
        this.label = label;
    }
}

export class SelectElementWithBusinessValue<T> extends SelectElement {
    businessValue: T;

    constructor(value: any, label: string, businessValue: T) {
        super(value, label);
        this.businessValue = businessValue;
    }
}
